import * as React from 'react';
import useAppDispatch from '@data/useAppDispatch';
import { fetchProfilePicture } from '@data/profiles/Profile.thunk';

const useProfilePicture = (targetId?: number) => {
  const [profilePicture, setProfilePicture] = React.useState<string | null>(
    null,
  );

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    setProfilePicture(null);
  }, [targetId]);

  React.useEffect(() => {
    let isActive = true;

    if (targetId) {
      dispatch(
        fetchProfilePicture({
          targetId,
        }),
      ).then((url) => {
        if (isActive) {
          setProfilePicture(url);
        }
      });
    }

    return () => {
      isActive = false;
    };
  }, [targetId, dispatch]);

  return profilePicture;
};

export default useProfilePicture;
